import { css } from '@lastbrand/web-ui-styled-system/css'

// Panda twin of BundleProductCard.module.scss — 1:1 visual translation of the `_newDesignV2` variants
// (the only variants still rendered; legacy fluid-rem values converted at a 10px root).

// `css.raw` (not `css`) so these compose via mergeLegacyResponsiveStyles at the call site:
// the add-on variants override the base by the SAME property keys in one merged css() call,
// which is deterministic — unlike cx(css(A), css(B)), where atomic-class order is not source
// order (see ai-guidelines/project/ds-migration.md).
export const bundleCardWrapperCss = css.raw({
  borderTop: '1px solid',
  borderColor: 'lightgray',
  paddingBlock: 'space-40',
  display: 'flex',
  flexDirection: 'column',
})

export const addOnBundleCss = css.raw({
  backgroundColor: 'paperwhite', // exact token match for legacy #F7F7F5
  // Longhand (not shorthand `padding`) so it overrides the base's `paddingBlock` on merge;
  // legacy `.addOnBundle` is all-sides 12px mobile / 20px desktop.
  paddingBlock: { base: 'space-12', lg: 'space-20' },
  paddingInline: { base: 'space-12', lg: 'space-20' },
  borderTop: 'none',
  marginBottom: 'space-32',
})

export const bundleCardCss = css({
  display: 'flex',
})

export const imageContainerCss = css.raw({
  marginRight: 'space-20',
  // image-tile dimensions from the Figma ProductTileBundle spec; not on the spacing scale
  width: '90px',
  height: '115px',
  flexShrink: 0,
})

export const addOnProductImageContainerCss = css.raw({
  // legacy 10px mobile / 18px desktop -> nearest tokens (space-18 does not exist)
  marginRight: { base: 'space-10', lg: 'space-16' },
  // image-tile dimensions from the legacy spec (50x67 / 60x81); not on the spacing scale —
  // space-50/space-60 are not valid tokens and would fail silently
  width: { base: '50px', lg: '60px' },
  height: { base: '67px', lg: '81px' },
})

export const productDetailsCss = css({
  width: 'full',
})

export const productOptionsContainerCss = css({
  marginTop: 'space-24',
})

export const productOptionsSpacingCss = css({
  marginTop: 'space-24',
  marginBottom: 'space-24',
  width: 'fit-content',
})

// Top offset comes from ProductPropertyDS's content wrapper; declaring it here too
// would duplicate the same value and race it in the Panda cascade.
export const siblingOptionsSelectorCss = css({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 'space-10',
})

export const sizeChartWrapperCss = css({
  paddingTop: 'space-6',
})

export const textOptionLabelNewDesignV2Css = css({
  backgroundColor: 'white',
})

export const errorMessageCss = css({
  textStyle: 'body-14', // legacy 13px/19px -> nearest token (14px/20px)
  fontWeight: 300, // legacy light weight; no light textStyle variant exists
  color: 'red-100',
  marginTop: 'space-8',
})
